import React from 'react';

import ContentWell from '@components/libraryV2/ContentWell';
import ExamCategoryDetailedLinks from '@components/libraryV2/ExamCategoryDetailedLinks';
import ExamCategoryLinks from '@components/libraryV2/ExamCategoryLinks';
import FancyLink from '@components/libraryV2/FancyLink';
import ThemeText from '@components/libraryV2/ThemeText';

import * as styles from './styles.module.scss';

const DefaultLinks = () => (
  <>
    <ExamCategoryLinks category="finra" />
    <ExamCategoryLinks category="nasaa" />
    <ExamCategoryLinks category="insurance" />
    <ExamCategoryLinks category="education" />
  </>
);
const DetailedLinks = () => (
  <>
    <ExamCategoryDetailedLinks category="finra" />
    <ExamCategoryDetailedLinks category="nasaa" />
    <ExamCategoryDetailedLinks category="insurance" />
    <ExamCategoryDetailedLinks category="education" />
  </>
);

const ExamCategories = (props) => {
  const { size, type = 'default' } = props;
  const isDetailed = type === 'detailed';

  return (
    <ContentWell size={size} secondary tighten>
      <div className={styles.heading}>
        <ThemeText>Exam prep</ThemeText> courses
      </div>
      <div className={styles.layout}>
        {isDetailed ? <DetailedLinks /> : <DefaultLinks />}
        <div className={styles.link}>
          <div>Can&apos;t find your course?</div>
          <FancyLink
            href="https://app.achievable.me/study/achievable/catalog"
            rel="noopener noreferrer"
            target="_blank"
            withArrow
          >
            See all courses
          </FancyLink>
        </div>
      </div>
    </ContentWell>
  );
};

export default ExamCategories;
